var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppFactoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59 59",
    style: {
      enableBackground: "new 0 0 59 59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#444444;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,3C14.9,3,3,14.9,3,29.5S14.9,56,29.5,56S56,44.1,56,29.5S44.1,3,29.5,3z M18.7,41.3l9.1-15l2.1,2.8 l-7.3,12.2L18.7,41.3z M26.8,41.1l1.4-2.4l4-7l2.2,3l0.1,0l-1.7,2.9h9l-12.2-21L15.1,40.7l-3-1.8L29.6,9.8l18.2,31.3H26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,0C13.2,0,0,13.2,0,29.5S13.2,59,29.5,59S59,45.8,59,29.5S45.8,0,29.5,0z M29.5,56C14.9,56,3,44.1,3,29.5 S14.9,3,29.5,3S56,14.9,56,29.5S44.1,56,29.5,56z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12.1,38.9 15.1,40.7 29.6,16.6 41.8,37.6 32.8,37.6 34.5,34.7 34.4,34.7 32.2,31.7 28.2,38.7  26.8,41.1 47.8,41.1 29.6,9.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.9,26.2 18.7,41.3 22.7,41.2 29.9,29  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppFactoryIcon);
export default __webpack_public_path__ + "static/media/AppFactory-icon.ac524261b02578963b172a38bfdeead1.svg";
export { ForwardRef as ReactComponent };